<template src="@/templates/report/job/activity.html"></template>

<script>
    import JobActivityReportCollection from "@/collections/jobActivityReportCollection"
    import JobActivityReportModel from "@/models/jobActivityReportModel"
    import {downloadFileMixin} from "@/mixins/functions/downloadFileMixin"
    import {mapActions} from 'vuex'

    export default {
        name: "JobActivity",
        mixins: [
            downloadFileMixin
        ],
        data() {
            return {
                jobActivityReportCollection: new JobActivityReportCollection(),
                jobActivityReportModel: new JobActivityReportModel(),
                pushTo: 'jobActivity'
            }
        },
        created() {
            this.fetchJobActivityReport()
        },
        methods: {
            ...mapActions(["updateIcon", "updateResourceCategoryHide", "updateClockOnOffHide", "updateAcceptDeclineHide", "updateSearchStateHide", "updateCameraStateHide"]),
            fetchJobActivityReport() {

                this.updateIcon([]);
                this.updateClockOnOffHide(true);
                this.updateAcceptDeclineHide(true);
                this.updateSearchStateHide(true);
                this.updateResourceCategoryHide(true);
                this.updateCameraStateHide(true);

                this.jobActivityReportCollection.getList().then(JARCollectionRes => {
                    this.jobActivityReportCollection.models = JARCollectionRes.response.data.data;

                }).catch((PCError) => {
                    let errorMessage = "Network error. " + PCError;
                    this.fetchError(errorMessage);
                    console.error(PCError);
                });
            },
            fetchError(errorMessage) {
                this.$vs.notify({
                    title: 'Network Error',
                    text: errorMessage,
                    time: 4000,
                    color: 'danger',
                    position: 'top-center'
                })
            },
            downloadPaySlip(paynum) {
                var paySlipId = paynum;

                  console.log('paynum', paynum);

                this.$vs.loading({
                    type: 'material',
                });
                this.jobActivityReportModel.paySlipId = paySlipId;
                this.files.jobActivity.paynum = paynum;
                this.jobActivityReportModel.getPaySlip().then(JARModelRes => {
                    let res = JARModelRes.response.data;

                    if (res) {
                        this.files.fileRawData = res;
                        this.downloadFile;

                        this.updateRead(paySlipId);
                    }

                    this.$vs.loading.close();

                }).catch((PCError) => {
                    let errorMessage = "Network error. " + PCError;
                    this.fetchError(errorMessage);
                    console.error(PCError);
                });
            },
            updateRead(id) {
                for (let i = 0; i < this.jobActivityReportCollection.models.length; i++) {
                    if (this.jobActivityReportCollection.models[i].paynum == id) {
                        // this.jobActivityReportCollection.models[i].int_view = 1;
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .badge {
        color: white;
        background-color: #F57E21;
    }
</style>
